import React from "react";
import { classnames } from "../../utils/text";

const ToolTip = ({
  position = "top",
  tooltiptext,
  children,
  className,
  boxStyle = {},
  ...props
}) => {
  return (
    <div className={classnames("custom-tooltip", className)} {...props}>
      {children ? children : <i className="bx bx-help-circle" />}
      <span style={boxStyle} className={classnames('tooltiptext', position)}>{tooltiptext}</span>
    </div>
  );
};

export default ToolTip;
